import { FunctionComponent, useCallback } from "react";
import { IIconProps } from "../../../../assets/icons/icon";
import { useTranslation } from "react-i18next";

export const GeneVariationExplanationHeroMobile: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  const translator = useTranslation().t;
  const t = useCallback((key: string) => translator(`gene_variations.page_2.hero.${key}`), [translator]);

  return (
    <svg viewBox="0 0 378 437" {...rest}>
      <defs>
        <rect id="gene-variation-mob-path-1" x="0" y="0" width="328" height="98" rx="16"></rect>
        <rect id="gene-variation-mob-path-3" x="0" y="0" width="69" height="437"></rect>
      </defs>
      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile-11b-Overview-Ergebnisse-+" transform="translate(10.000000, -692.000000)">
          <g id="Group" transform="translate(0.000000, 692.000000)">
            <g id="UI-Elements/Card/Nährstoffe-Copy-3" transform="translate(9.000000, 74.000000)">
              <mask id="gene-variation-mob-mask-2" fill="white">
                <use href="#gene-variation-mob-path-1"></use>
              </mask>
              <rect stroke="#ECECEC" strokeWidth="2" x="-1" y="-1" width="330" height="100" rx="16"></rect>
              <g id="Funktion" mask="url(#gene-variation-mob-mask-2)">
                <g transform="translate(17.000000, 16.000000)">
                  <g id="3" transform="translate(31.000000, 43.000000)">
                    <text
                      id="T/G"
                      fontFamily="Navigo-Light, Navigo"
                      fontSize="16"
                      fontWeight="300"
                      line-spacing="24"
                      fill="#222222"
                    >
                      <tspan x="86" y="18">
                        A/A
                      </tspan>
                    </text>
                    <text id="Genotyp" fontFamily="Navigo-Bold, Navigo" fontSize="14" fontWeight="bold" fill="#222222">
                      <tspan x="0" y="19">
                        Genotyp
                      </tspan>
                    </text>
                  </g>
                  <g id="2" transform="translate(31.000000, 21.000000)">
                    <text
                      id="rs8055236"
                      fontFamily="Navigo-Light, Navigo"
                      fontSize="16"
                      fontWeight="300"
                      line-spacing="24"
                      fill="#222222"
                    >
                      <tspan x="86" y="18">
                        rs662799
                      </tspan>
                    </text>
                    <text
                      id="rsNCBI-Copy"
                      fontFamily="Navigo-Bold, Navigo"
                      fontSize="14"
                      fontWeight="bold"
                      fill="#222222"
                    >
                      <tspan x="0" y="20">
                        rsNCBI
                      </tspan>
                    </text>
                  </g>
                  <g id="HL">
                    <text
                      id="CHD13"
                      fontFamily="Navigo-Bold, Navigo"
                      fontSize="18"
                      fontWeight="bold"
                      line-spacing="22"
                      fill="#222222"
                    >
                      <tspan x="31" y="21">
                        APOA5
                      </tspan>
                    </text>
                    <g id="Icons/Level/Gene/1" transform="translate(0.000000, 4.000000)">
                      <circle id="Oval" fill="#3A6D79" cx="8" cy="8" r="8"></circle>
                      <g
                        id="Group"
                        transform="translate(7.903728, 8.000000) rotate(90.000000) translate(-7.903728, -8.000000) translate(4.903728, 4.403728)"
                        stroke="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.75"
                      >
                        <path
                          d="M2.9988,1.19254305 C3.002,1.24590512 3.002,1.36336214 2.9988,1.54491411 L3.00093333,7.19254305"
                          id="Path"
                        ></path>
                        <polyline id="Path" points="0 3 3 0 6 3"></polyline>
                      </g>
                    </g>
                    <g id="Icons/Level/Gene/1-Copy" transform="translate(0.000000, 25.000000)">
                      <circle id="Oval" fill="#3A6D79" opacity="0.3" cx="8" cy="8" r="8"></circle>
                      <g
                        id="Group"
                        transform="translate(7.903728, 8.000000) scale(-1, 1) rotate(90.000000) translate(-7.903728, -8.000000) translate(4.903728, 4.403728)"
                        stroke="#FFFFFF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.75"
                      >
                        <path
                          d="M2.9988,1.19254305 C3.002,1.24590512 3.002,1.36336214 2.9988,1.54491411 L3.00093333,7.19254305"
                          id="Path"
                        ></path>
                        <polyline id="Path" points="0 3 3 0 6 3"></polyline>
                      </g>
                    </g>
                  </g>
                  <g id="People" transform="translate(233.000000, 3.821107)">
                    <circle id="Oval" stroke="#ECECEC" strokeWidth="3" cx="29" cy="29.1788934" r="29"></circle>
                    <path
                      d="M15.5631865,3.47295223 C6.31212349,8.31853456 0,18.0115763 0,29.1788934 C0,45.1951511 12.9837423,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                      id="94"
                    ></path>
                    <path
                      d="M1.27752326,20.6400689 C0.447032725,23.3395504 0,26.2070168 0,29.1788934 C0,45.1951511 12.9837423,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                      id="76"
                      stroke="#3A6D79"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M11.2285157,52.0972917 C16.1373803,55.9092616 22.3036397,58.1788934 29,58.1788934 C45.0162577,58.1788934 58,45.1951511 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                      id="58"
                    ></path>
                    <path
                      d="M37.966449,56.7661547 C49.5942401,52.9894905 58,42.0658272 58,29.1788934 C58,13.1626357 45.0162577,0.178893398 29,0.178893398"
                      id="47"
                      stroke="#3A6D79"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M48.7624921,7.95507316 C43.5834455,3.13048781 36.6364137,0.178893398 29,0.178893398"
                      id="13"
                    ></path>
                    <path
                      d="M35.0978973,0.821106602 C33.1317682,0.400353699 31.0917465,0.178893398 29,0.178893398"
                      id="2"
                      stroke="#3A6D79"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <text
                      id="2%"
                      fontFamily="Navigo-Bold, Navigo"
                      fontSize="13.5333333"
                      fontWeight="bold"
                      fill="#222222"
                    >
                      <tspan x="14.5389" y="34.1788934">
                        76%
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g id="Icons/Base/Info-Auge" mask="url(#gene-variation-mob-mask-2)">
                <g transform="translate(289.000000, 9.000000)">
                  <circle
                    id="Oval"
                    stroke="none"
                    fillOpacity="0.8"
                    fill="#FFFFFF"
                    fillRule="evenodd"
                    cx="14"
                    cy="14"
                    r="14"
                  ></circle>
                  <circle
                    id="Oval"
                    stroke="#222222"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    cx="14"
                    cy="14"
                    r="8"
                  ></circle>
                  <g
                    id="?"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(11.100000, 9.700000)"
                  >
                    <path
                      d="M2.62507213,6.02929688 C3.076244,6.02929688 3.35163463,5.8125 3.48640025,5.40234375 C3.60358775,4.98046875 3.7559315,4.76953125 4.55866588,4.30664062 C5.419994,3.80859375 5.82429088,3.2109375 5.82429088,2.34960938 C5.82429088,0.92578125 4.65827525,0 2.88288463,0 C1.5528065,0 0.574290879,0.50390625 0.181712754,1.2421875 C0.0586658789,1.46484375 7.21288574e-05,1.69335938 7.21288574e-05,1.9453125 C-0.00578724614,2.47265625 0.345775254,2.8125 0.896556504,2.8125 C1.30671275,2.8125 1.64069713,2.61914062 1.810619,2.23828125 C1.99225963,1.81054687 2.30866588,1.59375 2.77741588,1.59375 C3.30475963,1.59375 3.685619,1.92773438 3.685619,2.40234375 C3.685619,2.90625 3.48054088,3.15820312 2.68366588,3.62695312 C2.044994,3.99023438 1.69929088,4.41796875 1.69929088,5.05664062 L1.69929088,5.09179688 C1.69929088,5.6484375 2.06257213,6.02929688 2.62507213,6.02929688 Z M2.654369,8.72460938 C3.263744,8.72460938 3.76179088,8.26171875 3.76179088,7.66992188 C3.76179088,7.08398438 3.263744,6.62109375 2.654369,6.62109375 C2.03913463,6.62109375 1.54694713,7.08398438 1.54694713,7.66992188 C1.54694713,8.26171875 2.03913463,8.72460938 2.654369,8.72460938 Z"
                      id="Shape"
                      fill="#222222"
                      fillRule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
            <text
              id="Um-dieses-Gen-geht’s"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="19.9269931" y="26">
                {t("top_middle")}
              </tspan>
            </text>
            <path
              d="M101.41956,37.827792 C100.470089,37.5928844 100.894814,40.0641844 101.862737,40.5762112 C103.76592,41.5836539 105.65199,42.4992881 107.529661,43.3434524 C99.9486891,45.351719 91.76429,51.5449465 90.1405882,63.4288323 C90.1459979,63.8663237 90.0845174,64.4413249 89.9561467,65.1538358 C89.7413149,67.8669951 89.4601436,83.9297558 89.8386165,87.2299795 C89.9933919,88.5795963 90.9999324,88.3347571 90.9354627,85.9447522 C90.6577289,75.6486865 91.7841834,66.8053713 92.288289,64.194847 C92.3366301,63.9594952 92.3791246,63.7136351 92.4335609,63.4941617 C95.4077857,51.4707951 103.718772,45.9048668 112.505075,45.3978275 C112.59085,45.3922287 112.661026,45.3507162 112.723956,45.2974108 C112.937653,45.4267099 113.15196,45.5575968 113.366696,45.6919626 C112.747014,48.0139865 111.879919,49.8024592 110.649239,51.3096607 C109.971783,52.1399381 111.387869,54.7262226 112.068236,53.8893621 C113.742533,51.8329356 114.759507,49.3911982 115.459618,45.963433 C115.613353,45.2139539 114.971579,44.1394957 114.46976,43.8074449 C109.9756,40.8414317 105.680205,38.88674 101.41956,37.827792 Z"
              id="Fill-1"
              fill="#000000"
              transform="translate(98.621889, 64.663192) scale(-1, 1) rotate(-27.000000) translate(-98.621889, -64.663192) "
            ></path>
            <text
              id="Hier-kannst-du-mehr"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="184.926993" y="16">
                {t("right_top.line_1")}
              </tspan>
              <tspan x="184.926993" y="35">
                {t("right_top.line_2")}
              </tspan>
            </text>
            <path
              d="M305.2233,69.6846469 C305.1273,69.5446469 304.9823,69.4446469 304.7863,69.4096469 C302.6663,68.0766469 300.5463,66.7436469 298.4263,65.4096469 C297.4463,64.7936469 296.5453,66.3456469 297.5213,66.9576469 C298.8883,67.8166469 300.2553,68.6756469 301.6223,69.5336469 C292.4983,69.7936469 281.729635,68.5909419 274.061583,64.5966866 C267.869884,61.3714572 266.559194,58.9408609 263.924362,52.720434 C263.490803,51.6968673 262.583944,51.665036 263.016652,53.2695033 C264.277095,57.9431805 266.160876,61.9227966 270.421782,64.5966866 C279.791636,70.4766469 290.3103,71.4626469 301.6313,71.2206469 C299.7093,72.4866469 297.7373,73.6526469 295.6643,74.7106469 C294.7533,75.1766469 295.3963,76.5636469 296.3453,76.3256469 C300.0043,75.4106469 303.2813,74.0216469 306.4833,72.0206469 C307.0623,71.6586469 307.0593,70.8386469 306.4833,70.4766469 C306.0633,70.2126469 305.6433,69.9486469 305.2233,69.6846469 Z"
              id="Fill-1"
              fill="#000000"
              transform="translate(284.909493, 64.176361) scale(1, -1) rotate(97.000000) translate(-284.909493, -64.176361) "
            ></path>
            <text
              id="Dieser-Wert-klassifi"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="40.9269931" y="216">
                {t("mobile.bottom_right.line_1")}{" "}
              </tspan>
              <tspan x="40.9269931" y="235">
                {t("mobile.bottom_right.line_2")}{" "}
              </tspan>
              <tspan x="40.9269931" y="254">
                {t("mobile.bottom_right.line_3")}
              </tspan>
              <tspan x="43.9269931" y="272">
                {t("mobile.bottom_right.line_4")}
              </tspan>
            </text>
            <path
              d="M207.76511,176.200324 C207.660416,176.045107 207.502284,175.934238 207.288533,175.895434 C204.976534,174.41755 202.664535,172.939665 200.352537,171.460672 C199.283782,170.777719 198.301183,172.498406 199.365575,173.176925 C200.856378,174.12929 202.347181,175.081655 203.837984,176.032912 C193.887665,176.321171 182.143731,174.987744 173.781219,170.559351 C167.028766,166.98357 165.599373,164.28879 162.725916,157.392262 C162.253091,156.257443 161.264102,156.222152 161.735999,158.00101 C163.110594,163.182672 165.164981,167.594834 169.811777,170.559351 C180.030216,177.078407 191.501508,178.171576 203.847799,177.903273 C201.751732,179.306875 199.601137,180.599608 197.340395,181.772603 C196.34689,182.289253 197.048123,183.827006 198.08307,183.563138 C202.073449,182.548686 205.647232,181.008715 209.139222,178.790225 C209.77066,178.388879 209.767388,177.479753 209.139222,177.078407 C208.681185,176.785713 208.223147,176.493018 207.76511,176.200324 Z"
              id="Fill-1-Copy"
              fill="#000000"
              transform="translate(185.611574, 170.093339) scale(-1, 1) rotate(54.000000) translate(-185.611574, -170.093339) "
            ></path>
            <text
              id="Der-Genotyp-beschrei"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="40.9269931" y="307">
                {t("mobile.bottom_1.line_1")}{" "}
              </tspan>
              <tspan x="40.9269931" y="326">
                {t("mobile.bottom_1.line_2")}{" "}
              </tspan>
            </text>
            <text
              id="Dieser-Anteil-der-We"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="231.926993" y="218">
                {t("right_middle.line_1")}{" "}
              </tspan>
              <tspan x="231.926993" y="237">
                {t("right_middle.line_2")}{" "}
              </tspan>
              <tspan x="231.926993" y="256">
                {t("right_middle.line_3")}{" "}
              </tspan>
              <tspan x="231.926993" y="275">
                {t("right_middle.line_4")}
              </tspan>
            </text>
            <path
              d="M292.287755,161.625721 C289.14066,166.539417 279.221581,182.371469 273.663581,191.068469 C272.970581,188.117469 272.273581,185.166469 271.573581,182.216469 C271.347581,181.262469 269.719581,181.440469 269.826581,182.452469 C270.323581,187.148469 270.819581,191.843469 271.316581,196.538469 C271.398581,197.319469 272.221581,197.694469 272.834581,197.167469 C276.825581,193.739469 280.825581,190.319469 284.804581,186.876469 C285.666581,186.130469 284.415581,184.895469 283.556581,185.628469 C279.997581,188.663469 276.454581,191.718469 272.907581,194.767469 C272.881581,194.520469 272.855581,194.273469 272.829581,194.026469 C273.219581,194.244469 273.779581,194.148469 274.044581,193.729469 C280.612581,183.309469 287.175581,172.887469 293.733581,162.460469 C296.838581,157.522469 295.43485,156.712024 292.287755,161.625721 Z"
              id="Fill-1"
              fill="#000000"
              transform="translate(282.647344, 177.867807) rotate(-14.000000) translate(-282.647344, -177.867807) "
            ></path>
            <g id="Group-2" transform="translate(40.926993, 385.000000)">
              <text
                id="Vorwärtsstrang-Umgek"
                fontFamily="Navigo-Light, Navigo"
                fontSize="14"
                fontWeight="300"
                line-spacing="19"
                fill="#222222"
              >
                <tspan x="20" y="16">
                  {t("left_middle.line_1")}
                </tspan>
                <tspan x="20" y="35">
                  {t("left_middle.line_2")}
                </tspan>
              </text>
              <g id="Icons/Level/Blut/4" transform="translate(0.000000, 4.000000)">
                <circle id="Oval" fill="#3A6D79" cx="7" cy="7" r="7"></circle>
                <g
                  id="Group"
                  transform="translate(6.915762, 7.000000) rotate(90.000000) translate(-6.915762, -7.000000) translate(4.290762, 3.853262)"
                  stroke="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.3125"
                >
                  <path
                    d="M2.62395,1.04347517 C2.62675,1.09016698 2.62675,1.19294187 2.62395,1.35179984 L2.62581667,6.29347517"
                    id="Path"
                  ></path>
                  <polyline id="Path" points="0 2.625 2.625 2.51282215e-14 5.25 2.625"></polyline>
                </g>
              </g>
              <g id="Icons/Level/Blut/4-Copy" transform="translate(0.000000, 24.000000)">
                <circle id="Oval" fill="#3A6D79" cx="7" cy="7" r="7"></circle>
                <g
                  id="Group"
                  transform="translate(6.915762, 7.000000) scale(-1, 1) rotate(90.000000) translate(-6.915762, -7.000000) translate(4.290762, 3.853262)"
                  stroke="#FFFFFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.3125"
                >
                  <path
                    d="M2.62395,1.04347517 C2.62675,1.09016698 2.62675,1.19294187 2.62395,1.35179984 L2.62581667,6.29347517"
                    id="Path"
                  ></path>
                  <polyline id="Path" points="0 2.625 2.625 3.1343304e-14 5.25 2.625"></polyline>
                </g>
              </g>
            </g>
            <text
              id="Die-Symbole-zeigen-d"
              fontFamily="Navigo-Light, Navigo"
              fontSize="14"
              fontWeight="300"
              line-spacing="19"
              fill="#222222"
            >
              <tspan x="40.9269931" y="360">
                {t("mobile.bottom_2.line_1")}{" "}
              </tspan>
              <tspan x="40.9269931" y="379">
                {t("mobile.bottom_2.line_2")}{" "}
              </tspan>
            </text>
            <g id="gene-variation-explanation-mobile-group-3" transform="translate(0.000000, 132.000000)">
              <g id="Rectangle" />
              <path
                d="M103.811646,61.9089456 C102.186628,61.3493805 101.195847,63.8087457 102.654592,64.6336365 C105.522372,66.2562052 108.424435,67.7869304 111.362496,69.2479225 C98.9565409,54.5425109 -87.6826658,148.222478 -83.2641228,171.908174 C-82.2530274,175.939781 -82.1707842,174.252846 -82.308605,173.957289 C-84.0842939,145.59752 109.832813,58.8899824 119.280174,72.9488759 C119.341016,73.0394163 119.609292,72.9607815 119.766994,72.9335686 C120.077256,73.1308621 120.387518,73.3298563 120.696065,73.5322522 C117.83857,75.477974 114.90051,76.8369178 111.479058,77.8029755 C109.595203,78.3353277 110.395713,81.257312 112.289853,80.7198574 C116.948924,79.4000321 120.644641,77.4849248 124.45692,74.5357276 C125.291713,73.8911222 124.858032,72.6580381 124.150086,72.168206 C117.804287,67.7886312 111.10023,64.4244374 103.811646,61.9089456 Z"
                id="Fill-1"
                fill="#000000"
                mask="url(#gene-variation-explanation-mobile-mask-4)"
                transform="translate(20.786236, 118.192659) scale(-1, 1) rotate(115.000000) translate(-20.786236, -118.192659) "
              />
              <path
                d="M80.3710851,45.9697981 C78.7460669,45.410233 77.7552858,47.8695981 79.214031,48.6944889 C82.081811,50.3170576 84.9838741,51.8477828 87.9219344,53.3087749 C44.5705575,52.8836015 -34.2781304,106.305217 -20.4021097,136.06244 C-20.0403292,136.838281 -20.0403292,136.838281 -19.8994936,135.828066 C-21.0918038,91.1842722 79.833937,46.7459217 95.8396127,57.0097283 C95.9675224,57.0917517 96.1687303,57.0216339 96.3264325,56.994421 C96.6366944,57.1917145 96.9469563,57.3907088 97.2555041,57.5931047 C94.398009,59.5388265 91.4599487,60.8977703 88.0384969,61.8638279 C86.1546414,62.3961801 86.9551514,65.3181645 88.8492919,64.7807098 C93.508363,63.4608846 97.2040795,61.5457773 101.016358,58.5965801 C101.851152,57.9519747 101.417471,56.7188905 100.709525,56.2290584 C94.3637259,51.8494836 87.6596688,48.4852898 80.3710851,45.9697981 Z"
                id="Fill-1"
                fill="#000000"
                mask="url(#gene-variation-explanation-mobile-mask-4)"
                transform="translate(39.727690, 91.252878) scale(-1, 1) rotate(115.000000) translate(-39.727690, -91.252878) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
